/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Field_IntegrityInputs */



/**
* | output |
* | --- |
* | "Integrity hash (optional)" |
*
* @param {Partner_Connectors_Field_IntegrityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_field_integrity = /** @type {((inputs?: Partner_Connectors_Field_IntegrityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Field_IntegrityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Integritäts-Hash (optional)")
	return /** @type {LocalizedString} */ ("Integrity hash (optional)")
});